






























































/* Created- 09 - Sep - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { CustomerUrlModel } from "../../Generated/ParticaAPI";
@Component(
	{
		name: "DomainSecurity"
	})
export default class DomainSecurity extends Vue {
	@Prop() private CustomerUrlModel: CustomerUrlModel; // your data
}
